/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Exhausted_WeekInputs */

const fr_calendar_quota_exhausted_week = /** @type {(inputs: Calendar_Quota_Exhausted_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes tes séances de la semaine sont utilisées`)
};

/**

* @param {Calendar_Quota_Exhausted_WeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_exhausted_week = /** @type {((inputs?: Calendar_Quota_Exhausted_WeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Exhausted_WeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_exhausted_week(inputs)
});